import React from "react";

const Gelato = ({nome, descrizione, img, prezzo, categoria}) => {
  //console.log(props);
  
  return <article className="gelato">
    <div className="img-container">
      <img src={img} alt={nome} className="img"/>
    </div>
    <div className="prd-info">
      <header className="prd-header">
        <div>
          <h5>{nome}</h5>
          <h6>{categoria}</h6>
        </div>
        <span className="prd-prezzo">
          {(prezzo / 100).toFixed(2)} €
        </span>
      </header>
      <p>{descrizione}</p>
    </div>
  </article>;
};

export default Gelato;
